/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateTagDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivTagControllerFindAllByPartnerIdParamsGen,
  MrfiktivTagViewModelGen,
  MrfiktivUpdateTagDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Tag<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Tag
   * @name TagControllerCreate
   * @summary Create a new tag
   * @request POST:/partner/{partnerId}/tag
   * @secure
   * @response `201` `MrfiktivTagViewModelGen` The tag has been successfully created.
   */
  tagControllerCreate = (partnerId: string, data: MrfiktivCreateTagDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivTagViewModelGen, any>({
      path: `/partner/${partnerId}/tag`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Tag
   * @name TagControllerFindAllByPartnerId
   * @summary Get all tags for a partner
   * @request GET:/partner/{partnerId}/tag
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivTagViewModelGen)[] })`
   */
  tagControllerFindAllByPartnerId = (
    { partnerId, ...query }: MrfiktivTagControllerFindAllByPartnerIdParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivTagViewModelGen[] }, any>({
      path: `/partner/${partnerId}/tag`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Tag
   * @name TagControllerFindOne
   * @summary Get a tag by id
   * @request GET:/partner/{partnerId}/tag/{id}
   * @secure
   * @response `200` `MrfiktivTagViewModelGen` Returns the tag.
   */
  tagControllerFindOne = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivTagViewModelGen, any>({
      path: `/partner/${partnerId}/tag/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Tag
   * @name TagControllerUpdate
   * @summary Update a tag
   * @request PUT:/partner/{partnerId}/tag/{id}
   * @secure
   * @response `200` `MrfiktivTagViewModelGen` The tag has been successfully updated.
   */
  tagControllerUpdate = (partnerId: string, id: string, data: MrfiktivUpdateTagDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivTagViewModelGen, any>({
      path: `/partner/${partnerId}/tag/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Tag
   * @name TagControllerRemove
   * @summary Delete a tag
   * @request DELETE:/partner/{partnerId}/tag/{id}
   * @secure
   * @response `200` `MrfiktivTagViewModelGen` The tag has been successfully deleted.
   */
  tagControllerRemove = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivTagViewModelGen, any>({
      path: `/partner/${partnerId}/tag/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
}
